<template>
  <div class="ledger-tab">
    <!-- KPI Cards -->
    <revenue-card :item="kpiCards" />

    <!-- Analytics Dashboard Section -->
    <div class="analytics-grid">
      <!-- Chart Column (Left) -->
      <v-card
        class="analytics-card chart-card"
        flat
      >
        <v-card-text>
          <div class="card-header">
            <span class="card-title">Revenue & energy</span>
            <span class="card-subtitle">last 14 days</span>
          </div>

          <div class="chart-wrapper">
            <apexchart
              type="line"
              height="300"
              :options="chartOptions"
              :series="series"
            />
          </div>
        </v-card-text>
      </v-card>

      <!-- Side Cards Column (Right) -->
      <div class="side-column">
        <!-- Reliability Card -->
        <v-card
          class="analytics-card"
          flat
        >
          <v-card-text>
            <div class="card-header">
              <span class="card-title">Reliability</span>
              <span class="card-subtitle">vs SLA target</span>
            </div>

            <div class="reliability-list">
              <div
                v-for="(item, index) in reliabilityItems"
                :key="index"
                class="reliability-item"
              >
                <div class="item-info">
                  <span class="item-title">{{ item.title }}</span>
                  <span class="item-subtitle">{{ item.targetText }}</span>
                </div>

                <div class="item-value-group">
                  <span
                    class="item-value"
                    :class="item.type"
                  >
                    {{ item.value }}
                  </span>
                  <span
                    class="status-badge"
                    :class="`badge-${item.type}`"
                  >
                    <span class="dot">●</span> {{ item.badgeText }}
                  </span>
                </div>
              </div>
            </div>
          </v-card-text>
        </v-card>

        <!-- Sites by City Card -->
        <v-card
          class="analytics-card"
          flat
        >
          <v-card-text>
            <div class="card-header">
              <span class="card-title">Sites by city</span>
            </div>

            <div class="city-list">
              <div
                v-for="(city, index) in citySites"
                :key="index"
                class="city-item"
              >
                <span class="city-name">{{ city.name }}</span>

                <div class="progress-bar-container">
                  <div
                    class="progress-bar-fill"
                    :style="{ width: city.percentage + '%' }"
                  />
                </div>

                <span class="city-count">{{ city.count }} sites</span>
              </div>
            </div>
          </v-card-text>
        </v-card>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";

export default {
  components: {
    RevenueCard: () => import("../utils/RevenueCards.vue"),
    apexchart: VueApexCharts,
  },

  data() {
    return {
      kpiCards: [
        {
          title: "Revenue Today",
          value: "110,685.87",
          unit: "",
          text: "12.4% vs yesterday",
          progress: 50,
        },
        {
          title: "Energy Dispensed",
          value: 907.86,
          unit: "kWh",
          text: "8.1% vs yesterday",
          progress: 35,
        },
        {
          title: "Sessions Today",
          value: 42,
          unit: "",
          text: "4.5% vs yesterday",
          progress: 80,
        },
        {
          title: "New Users",
          value: 45,
          unit: "",
          text: "22% vs yesterday",
          progress: 100,
        },
      ],

      // ApexChart Data
      series: [
        {
          name: "Revenue",
          data: [25, 20, 32, 28, 42, 38, 52, 45, 58, 48, 62, 55, 68],
        },
        {
          name: "Energy",
          data: [20, 28, 25, 38, 35, 40, 50, 45, 60, 54, 62, 58, 62],
        },
      ],
      chartOptions: {
        chart: {
          type: "line",
          toolbar: { show: false },
          zoom: { enabled: false },
        },
        colors: ["#1b7a63", "#e08369"],
        stroke: {
          curve: "straight",
          width: 3,
        },
        markers: {
          size: [0, 0],
          hover: { size: 6 },
        },
        grid: {
          show: false,
        },
        xaxis: {
          labels: { show: false },
          axisBorder: { show: false },
          axisTicks: { show: false },
        },
        yaxis: {
          labels: { show: false },
        },
        legend: {
          position: "top",
          horizontalAlign: "left",
          fontSize: "13px",
          markers: {
            width: 12,
            height: 3,
            radius: 2,
          },
        },
        tooltip: {
          theme: "light",
        },
      },

      // Reliability Data
      reliabilityItems: [
        {
          title: "Charger availability",
          targetText: "SLA 98%",
          value: "38.75%",
          badgeText: "Breach",
          type: "breach",
        },
        {
          title: "Network availability",
          targetText: "SLA 99%",
          value: "43.77%",
          badgeText: "Breach",
          type: "breach",
        },
        {
          title: "First-time success",
          targetText: "Target 95%",
          value: "64.71%",
          badgeText: "Breach",
          type: "breach",
        },
        {
          title: "Mean time to repair",
          targetText: "Target 4h",
          value: "4.2h",
          badgeText: "Watch",
          type: "watch",
        },
      ],

      // Sites By City Data
      citySites: [
        { name: "Islamabad", count: 5, percentage: 100 },
        { name: "Karachi", count: 3, percentage: 60 },
      ],
    };
  },
};
</script>

<style lang="sass" scoped>
.ledger-tab
  width: 100%

.analytics-grid
  display: grid
  grid-template-columns: 1fr 0.55fr
  gap: 1rem
  margin-top: 1rem

.side-column
  display: flex
  flex-direction: column
  gap: 1rem

.analytics-card
  border-radius: 16px !important
  background: #ffffff !important
  border: 1px solid #f0f2f5

.chart-card
  display: flex
  flex-direction: column
  justify-content: space-between

.card-header
  display: flex
  align-items: baseline
  gap: 8px
  margin-bottom: 1rem

.card-title
  font-size: 16px
  font-weight: 700
  color: #111827

.card-subtitle
  font-size: 13px
  color: #9ca3af

.chart-wrapper
  margin-top: 1rem

/* Reliability Items */
.reliability-list
  display: flex
  flex-direction: column
  gap: 1rem

.reliability-item
  display: flex
  justify-content: space-between
  align-items: center
  padding-bottom: 0.75rem
  border-bottom: 1px solid #f3f4f6

  &:last-child
    border-bottom: none
    padding-bottom: 0

.item-info
  display: flex
  flex-direction: column

.item-title
  font-size: 14px
  font-weight: 600
  color: #1f2937

.item-subtitle
  font-size: 12px
  color: #9ca3af

.item-value-group
  display: flex
  align-items: center
  gap: 10px

.item-value
  font-size: 16px
  font-weight: 700

  &.breach
    color: #cc2929

  &.watch
    color: #d97706

.status-badge
  display: inline-flex
  align-items: center
  gap: 4px
  padding: 3px 8px
  border-radius: 12px
  font-size: 11px
  font-weight: 600

  .dot
    font-size: 8px

  &.badge-breach
    background-color: #fde8e8
    color: #e02424

  &.badge-watch
    background-color: #fef3c7
    color: #d97706

/* Sites By City */
.city-list
  display: flex
  flex-direction: column
  gap: 1rem
  margin-top: 0.5rem

.city-item
  display: grid
  grid-template-columns: 100px 1fr 60px
  align-items: center
  gap: 1rem

.city-name
  font-size: 14px
  font-weight: 600
  color: #1f2937

.progress-bar-container
  width: 100%
  height: 10px
  background-color: #f3f4f6
  border-radius: 6px
  overflow: hidden

.progress-bar-fill
  height: 100%
  background-color: #1b7a63
  border-radius: 6px

.city-count
  font-size: 13px
  color: #4b5563
  text-align: right
  font-weight: 500

@media (max-width: 1024px)
  .analytics-grid
    grid-template-columns: 1fr
</style>
